// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-K":"K_dpu-detail-K__tYD8Z"};